import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, CheckCircle2 } from 'lucide-react';
import { revealVariants } from '../utils/animations';
type FaqItem = {
  q: string;
  a: string | React.ReactNode;
};
const includedItems = ['Diseño profesional adaptado al rubro del cliente', 'Versión optimizada para celular — mobile first', 'Formulario de contacto activo', 'Botón de WhatsApp flotante', 'Dominio incluido por 1 año', 'SSL activo — candado de seguridad visible', 'Carga menor a 3 segundos en celular', 'Textos personalizados con los datos reales del negocio', 'Entrega en máximo 72 horas desde el pago', '1 año de mantenimiento gratuito y asesoramiento'];
const faqs: FaqItem[] = [{
  q: '¿Realmente entregan la web en 72hs?',
  a: 'Sí. Nuestro proceso está optimizado para ser rápido sin perder calidad. Una vez que nos enviás la información básica (logo, textos, fotos), empezamos a diseñar y en 72hs hábiles tenés tu web lista.'
}, {
  q: '¿Qué incluye el precio?',
  a: <div data-id="element-92">
        <div className="mb-4" data-id="element-93">
          <span className="text-white font-semibold" data-id="element-94">Lo que SÍ incluye — </span>
          <span className="text-gradient bg-gradient-to-r from-electric to-cyan font-bold text-xl" data-id="element-95">
            USD 390
          </span>
        </div>
        <ul className="space-y-2.5" data-id="element-96">
          {includedItems.map((item, i) => <li key={i} className="flex items-start text-neutral-300" data-id="element-97">
              <CheckCircle2 size={16} className="text-green-400 mr-3 mt-0.5 shrink-0" data-id="element-98" />
              <span data-id="element-99">{item}</span>
            </li>)}
        </ul>
      </div>
}, {
  q: '¿Tengo que pagar mantenimiento mensual?',
  a: 'No. Solo pagás el desarrollo por única vez e incluye 1 año de mantenimiento y asesoramiento gratuito. Al año siguiente solo deberás renovar el costo del hosting y dominio (que es muy accesible).'
}, {
  q: '¿Puedo pedir una web nueva en el futuro?',
  a: 'Sí. Si en el futuro querés rediseñar tu web o crear una nueva versión completamente diferente, te ofrecemos un descuento exclusivo para clientes existentes. También podés pedirnos cambios puntuales durante tu primer año de mantenimiento sin costo adicional.'
}, {
  q: '¿Incluye el dominio (.com o .com.ar)?',
  a: 'Sí, el dominio está incluido por el primer año. Te ayudamos a registrarlo a tu nombre para que seas el único dueño y luego solo se renueva anualmente a costo accesible.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 md:py-32 relative" data-id="element-100">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-101">
        <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-102">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tighter text-white" data-id="element-103">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-104">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} viewport={{
          once: true
        }} className="border border-white/10 rounded-xl bg-white/[0.02] overflow-hidden" data-id="element-105">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-106">
                <span className="text-lg font-medium text-white" data-id="element-107">{faq.q}</span>
                <ChevronDownIcon className={`text-neutral-400 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-108" />
              </button>
              <AnimatePresence data-id="element-109">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-110">
                    <div className="px-6 pb-6 text-neutral-400 font-light leading-relaxed" data-id="element-111">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}